import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';

import '!style-loader!css-loader!react-select/dist/react-select.css';
import styles from './ReactSelect.css';


export default class ReactSelect extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    clearable: PropTypes.bool,
    disabled: PropTypes.bool,
    errorText: PropTypes.string,
    fetchData: PropTypes.bool,
    id: PropTypes.string,
    isValid: PropTypes.bool,
    options: PropTypes.array,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    searchable: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.number,
      PropTypes.array,
      PropTypes.bool,
    ]),
    wrapperClass: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    className: undefined,
    clearable: undefined,
    disabled: undefined,
    errorText: undefined,
    fetchData: false,
    id: undefined,
    isValid: true,
    options: undefined,
    placeholder: undefined,
    searchable: undefined,
    value: undefined,
    wrapperClass: undefined,
    onChange: undefined,
  };

  renderError = () => {
    const { isValid, errorText } = this.props;

    if (isValid) {
      return null;
    }

    return (
      <span className={styles.errorText}>
        {errorText}
      </span>
    );
  };

  render() {
    const { isValid, wrapperClass, className, id, fetchData } = this.props;

    const SelectComponent = fetchData ? Select.Async : Select;

    const wrapperClassName = [wrapperClass, styles.selectWrapper];
    const selectClassName = [{ [styles.selectError]: !isValid }, className];

    return (
      <div className={classNames(wrapperClassName)}>
        <SelectComponent
          {...this.props}
          className={classNames(selectClassName)}
          instanceId={id}
        />
        {this.renderError()}
      </div>
    );
  }

}
